"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
/**
 * Calculate a capped, fully-jittered exponential backoff time.
 */
function defaultDelayDecider(delayBase, attempts) {
    return Math.floor(Math.min(constants_1.MAXIMUM_RETRY_DELAY, Math.random() * Math.pow(2, attempts) * delayBase));
}
exports.defaultDelayDecider = defaultDelayDecider;
//# sourceMappingURL=delayDecider.js.map